import {
  ButtonTracking,
  ScreenTracking,
  SCREEN_ASSET_ID
} from '../../domain/amplitude'

export const ScreenOpendedEvent: ScreenTracking = {
  screen: 'login',
  asset_id: SCREEN_ASSET_ID,
  from_screen: 'signUp',
  heading: 'Log In to Your Account.'
}

export const LoginButtonEvent: ButtonTracking = {
  screen: 'login',
  asset_id: 'nextButton',
  asset_text: 'NEXT'
}

export const ForgotButtonEvent: ButtonTracking = {
  screen: 'login',
  asset_id: 'nextButton',
  asset_text: 'Forgot password?'
}
